export default "__VITE_ASSET__7879fa45__"